import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "alert alert-success alert-dismissible fade show custom-alert p-2 mb-3",
  role: "alert"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "dashboard-two-section" }
const _hoisted_7 = { class: "dashboard-section" }
const _hoisted_8 = { class: "dashboard-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardSummaryTiles = _resolveComponent("DashboardSummaryTiles")!
  const _component_StyleAnalysesChart = _resolveComponent("StyleAnalysesChart")!
  const _component_ProductWiseSgcConsumption = _resolveComponent("ProductWiseSgcConsumption")!
  const _component_StylesCreatedForCustomers = _resolveComponent("StylesCreatedForCustomers")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$t("dashboard.LanguageChangeOptionisAvailableIn")) + " ", 1),
      _createElementVNode("a", {
        class: "profileLink",
        href: _ctx.PROFILE,
        target: "_blank"
      }, _toDisplayString(_ctx.$t("userSideMenuV1.myProfile")), 9, _hoisted_2),
      _cache[0] || (_cache[0] = _createElementVNode("button", {
        type: "button",
        class: "close",
        "data-dismiss": "alert",
        "aria-label": "Close"
      }, [
        _createElementVNode("span", { "aria-hidden": "true" }, "×")
      ], -1))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DashboardSummaryTiles, { summaryTilesData: _ctx.summaryTilesData }, null, 8, ["summaryTilesData"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_StyleAnalysesChart)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ProductWiseSgcConsumption)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_StylesCreatedForCustomers)
        ])
      ])
    ])
  ], 64))
}